var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "plan-feature" } }, [
    _c("div", { staticClass: "feature" }, [
      _c("div", { staticClass: "feature-title" }, [
        _vm._v("Hizmet Özellikleri"),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "feature-delete",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_c("span", { staticClass: "material-icons" }, [_vm._v("close")])]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "feature-form" }, [
      _c("div", { staticClass: "feature-item" }, [
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.flexiblePricing,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "flexiblePricing", $$v)
                  },
                  expression: "featureForm.flexiblePricing",
                },
              },
              [_vm._v(_vm._s(_vm.$t("plans.flexiblePricing")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.unlimitedCBScenario,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "unlimitedCBScenario", $$v)
                  },
                  expression: "featureForm.unlimitedCBScenario",
                },
              },
              [_vm._v(_vm._s(_vm.$t("plans.unlimitedCBScenario")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.freeFirstScenario,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "freeFirstScenario", $$v)
                  },
                  expression: "featureForm.freeFirstScenario",
                },
              },
              [_vm._v(_vm._s(_vm.$t("plans.freeFirstScenario")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.rightToCancel,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "rightToCancel", $$v)
                  },
                  expression: "featureForm.rightToCancel",
                },
              },
              [_vm._v(_vm._s(_vm.$t("plans.rightToCancel")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.unlimitedLearn,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "unlimitedLearn", $$v)
                  },
                  expression: "featureForm.unlimitedLearn",
                },
              },
              [_vm._v(_vm._s(_vm.$t("plans.unlimitedLearn")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.allPlatformIntegration,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "allPlatformIntegration", $$v)
                  },
                  expression: "featureForm.allPlatformIntegration",
                },
              },
              [_vm._v(_vm._s(_vm.$t("plans.allPlatformIntegration")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.aiSupport,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "aiSupport", $$v)
                  },
                  expression: "featureForm.aiSupport",
                },
              },
              [_vm._v(_vm._s(_vm.$t("plans.aiSupport")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.creativeAI,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "creativeAI", $$v)
                  },
                  expression: "featureForm.creativeAI",
                },
              },
              [_vm._v(_vm._s(_vm.$t("plans.creativeAI")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.unlimitedSession,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "unlimitedSession", $$v)
                  },
                  expression: "featureForm.unlimitedSession",
                },
              },
              [_vm._v(_vm._s(_vm.$t("plans.unlimitedSession")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.assistantFromWebsite,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "assistantFromWebsite", $$v)
                  },
                  expression: "featureForm.assistantFromWebsite",
                },
              },
              [_vm._v(_vm._s(_vm.$t("plans.assistantFromWebsite")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.assistantFromDoc,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "assistantFromDoc", $$v)
                  },
                  expression: "featureForm.assistantFromDoc",
                },
              },
              [_vm._v(_vm._s(_vm.$t("plans.assistantFromDoc")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.mobileApp,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "mobileApp", $$v)
                  },
                  expression: "featureForm.mobileApp",
                },
              },
              [_vm._v(_vm._s(_vm.$t("plans.mobileApp")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.whatsapp,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "whatsapp", $$v)
                  },
                  expression: "featureForm.whatsapp",
                },
              },
              [_vm._v("Whatsapp")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.email,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "email", $$v)
                  },
                  expression: "featureForm.email",
                },
              },
              [_vm._v("Email")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.web,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "web", $$v)
                  },
                  expression: "featureForm.web",
                },
              },
              [_vm._v("Web")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.instagram,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "instagram", $$v)
                  },
                  expression: "featureForm.instagram",
                },
              },
              [_vm._v("Instagram")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.messenger,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "messenger", $$v)
                  },
                  expression: "featureForm.messenger",
                },
              },
              [_vm._v("Messenger")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.mentionTicket,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "mentionTicket", $$v)
                  },
                  expression: "featureForm.mentionTicket",
                },
              },
              [_vm._v("Mention Ticket")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.privateReplyMessage,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "privateReplyMessage", $$v)
                  },
                  expression: "featureForm.privateReplyMessage",
                },
              },
              [_vm._v("Private Reply Message")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.commentManagement,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "commentManagement", $$v)
                  },
                  expression: "featureForm.commentManagement",
                },
              },
              [_vm._v("Comment Management")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.manageInbox,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "manageInbox", $$v)
                  },
                  expression: "featureForm.manageInbox",
                },
              },
              [_vm._v("Manage Inbox")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.manageWithChatbot,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "manageWithChatbot", $$v)
                  },
                  expression: "featureForm.manageWithChatbot",
                },
              },
              [_vm._v("Manage with Chatbot")]
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }